import { closeHeaderSearch } from './headerSearch';
const body = document.body;
const scrollUp = 'scroll-up';
const scrollDown = 'scroll-down';

const pageIntro: HTMLElement = document.getElementById('page-intro');

let lastScroll = 0;
let lockMenu = false;
const isCampaignPage = !!document.querySelector('.sticky-page-intro--white');
if (isCampaignPage) {
    const header = document.querySelector('#header');
    header?.classList.add('bg-white');
}

(function () {
    const topMenuButtonId = "topMenuButton";
    const spanTextId = "spanid"
    const divToExpandId = "underheaderSpace";
    const flipThisIconId = "flipThisIcon";
    var allButtons = document.querySelectorAll(`[id^=${topMenuButtonId}]`);
    var allSpans = document.querySelectorAll(`[id^=${spanTextId}]`);
    var allIcons = document.querySelectorAll(`[id^=${flipThisIconId}]`);
    var allDivsToExpand = document.querySelectorAll(`[id^=${divToExpandId}]`);
    var allCloseButtons = document.querySelectorAll(`[id^=${"closeAllButton"}]`);

    allCloseButtons.forEach(itemOnClick);
    allButtons.forEach(itemOnClick);

    const topMenuButtonMobileId = "topMenuButtonMobile";
    const spanMobileId = "spanMobileId"
    const ulToExpandId = "ulMobile";
    const ulChildToExpandId = "ulChildMobile";
    const childLinkMobileId = "childLinkMobileId";
    const allMobileButtons = document.querySelectorAll(`[id^=${topMenuButtonMobileId}]`);
    const allUlsToExpand = document.querySelectorAll(`[id^=${ulToExpandId}]`);
    const allChildUlsToExpand = document.querySelectorAll(`[id^=${ulChildToExpandId}]`);
    const allChildLinkMobile = document.querySelectorAll(`[id^=${childLinkMobileId}]`);
    const allNavigationIconMobileChild = document.querySelectorAll(`[id^=navigationIconMobileChild`);
    const allTopMenuIconUpMobileChild = document.querySelectorAll(`[id^=topMenuIconUpMobileChild`);
    const language = document.getElementById("language");
    const selectedLanguage = document.getElementById("selectedLanguage");   

    const backFirstPageButton = document.getElementById('backFirstPageButton');
    const backButton = document.getElementById('backPageButton');

    allUlsToExpand.forEach(hideUls);
    allChildUlsToExpand.forEach(hideUls);

    allButtons.forEach(itemOnClick);
    allMobileButtons.forEach(mobileItemOnClick);
    allChildLinkMobile.forEach(mobileChildLinkOnClick);

    function hideUls(item) {
        if (item.classList.contains('ulMarked')) {
            item.classList.remove('ulMarked');
        }

        item.style.display = 'none';
    }

    function itemOnClick(item) {
        item.onclick = function (e) {
            const index = e.currentTarget.getAttribute('index');
            const topMenuSpan = document.getElementById(spanTextId + index);
            const flipIcon = document.getElementById(flipThisIconId + index);
            const divToExpand = document.getElementById(divToExpandId + index);

            allSpans.forEach(unmarkSpans);
            allIcons.forEach(flipIcons);
            allDivsToExpand.forEach(hideDivs);

            function unmarkSpans(item) {
                if (item.id.indexOf(index) === -1) {
                    item.classList.remove('buttonSpanMarked');
                }
            }

            function flipIcons(item) {
                if (item.id.indexOf(index) === -1) {
                    item.style.transform = '';
                }
            }

            function hideDivs(item) {
                if (item.id.indexOf(index) === -1) {
                    item.style.display = 'none';
                }
            }

            if (topMenuSpan.classList.contains('buttonSpanMarked')) {
                topMenuSpan.classList.remove('buttonSpanMarked');
                removeOverlay();
                flipIcon.style.transform = '';
                divToExpand.style.display = 'none';
            } else {
                removeOverlay();
                closeHeaderSearch();
                addOverlayForHeader();
                topMenuSpan.classList.add('buttonSpanMarked');
                flipIcon.style.transform = 'rotate(180deg)';
                divToExpand.style.display = 'block';
            }
        };
    }
    function addOverlayForHeader() {
        lockMenu = true;
        const header = document.getElementById('header');
        const childElement = document.getElementById('underheaderSpace0'); // Change 'childElement' to the actual id of your child element

        const overlay = document.createElement('div');
        overlay.classList.add('overlay');

        const headerHeight = header ? header.clientHeight : 0;
        const childElementHeight = childElement ? childElement.clientHeight : 0;

        const overlayTop = headerHeight - childElementHeight; // Adjust the height accordingly

        overlay.style.top = `${overlayTop}px`;
        overlay.style.zIndex = "1"; // Ensure the overlay is behind the child element

        document.body.appendChild(overlay);
    }

    function removeOverlay() {
        lockMenu = false;
        const overlay = document.querySelector('.overlay');
        if (overlay) {
            overlay.remove();
        }
    }

    function handleResize() {
        const screenWidth = window.innerWidth;
        if (screenWidth < 1280) {
            removeOverlay();
        }
    }

    function showAllButtons(item) {
        item.style.display = 'inline-flex';
    }

    function removeStuffTopLevel(lightMenu) {
        allButtons.forEach(button => {
            button.classList.add('topLevelTitle');
        });

        if (backFirstPageButton !== null && lightMenu === "False") {
            backFirstPageButton.classList.add('hide');
        }
        if (backButton !== null) {
            backButton.classList.remove('hide');
        }
    }

    function showStuffTopLevel() {
        allButtons.forEach(button => {
            button.classList.remove('topLevelTitle');
        });

        if (backFirstPageButton !== null) {
            backFirstPageButton.classList.remove('hide');
        }
        if (backButton !== null) {
            backButton.classList.add('hide');
        }
    }

    window.addEventListener('resize', handleResize);

    function mobileItemOnClick(item) {
        item.onclick = function (e) {
            const index = e.currentTarget.getAttribute('index');
            const lightMenu = e.currentTarget.getAttribute('lightMenu');
            const topMenuSpan = document.getElementById(spanMobileId + index);
            const ulToExpand = document.getElementById(ulToExpandId + index);
            const navigationIconMobileParent = document.getElementById("navigationIconMobileParent" + index);
            const navigationIconMobileParentGlobe = document.getElementById("navigationIconMobileParentGlobe" + index);
            const topMenuIconUpMobileParent = document.getElementById("topMenuIconUpMobileParent" + index);
            let languageIndex = null;

            if (language !== null) {
                languageIndex = language.getAttribute('index');
            }

            allTopMenuIconUpMobileChild.forEach((item: HTMLElement) => {
                item.style.display = 'none';
            });

            allNavigationIconMobileChild.forEach((item: HTMLElement) => {
                item.style.display = 'block';
            });

            if (topMenuSpan.classList.contains('buttonSpanMarkedTopLevel')) {
                topMenuSpan.classList.remove('buttonSpanMarkedTopLevel');
                ulToExpand.style.display = 'none';
                showStuffTopLevel()

                if (navigationIconMobileParent !== null) {
                    navigationIconMobileParent.style.display = "block";
                }

                if (navigationIconMobileParentGlobe !== null) {
                    navigationIconMobileParentGlobe.style.display = "block";
                }

                if (topMenuIconUpMobileParent != null) {
                    topMenuIconUpMobileParent.style.display = "none";
                }

                if (languageIndex !== null && languageIndex == index) {
                    language.style.display = "none";
                    selectedLanguage.style.display = "flex";
                }

                allMobileButtons.forEach(showAllButtons);
            } else {
                allChildUlsToExpand.forEach(hideUls);
                topMenuSpan.classList.add('buttonSpanMarkedTopLevel');
                ulToExpand.style.display = 'block';
                removeStuffTopLevel(lightMenu)

                if (navigationIconMobileParent !== null) {
                    navigationIconMobileParent.style.display = "none";
                }

                if (navigationIconMobileParentGlobe !== null) {
                    navigationIconMobileParentGlobe.style.display = "none";
                }

                if (topMenuIconUpMobileParent != null) {
                    topMenuIconUpMobileParent.style.display = "block";
                }

                if (lightMenu !== null && lightMenu == "False") {
                    allMobileButtons.forEach(hideOtherButtons);
                    item.disabled = true;
                }

                if (languageIndex !== null && languageIndex == index) {
                    language.style.display = "flex";
                    selectedLanguage.style.display = "none";
                }

                function hideOtherButtons(item) {
                    if (item.id.indexOf(index) === -1) {
                        item.style.display = 'none';
                    }
                }
            }
        };
    }

    function mobileChildLinkOnClick(item) {
        item.onclick = function (e) {
            const index = e.currentTarget.getAttribute('index');
            const ulChildToExpand = document.getElementById(ulChildToExpandId + index);
            const navigationIconMobileChild = document.getElementById("navigationIconMobileChild" + index);
            const topMenuIconUpMobileChild = document.getElementById("topMenuIconUpMobileChild" + index);

            if (ulChildToExpand.classList.contains('ulMarked')) {
                ulChildToExpand.classList.remove('ulMarked');
                ulChildToExpand.style.display = 'none';
                navigationIconMobileChild.style.display = "block";

                if (topMenuIconUpMobileChild != null) {
                    topMenuIconUpMobileChild.style.display = "none";
                }
            } else {
                ulChildToExpand.classList.add('ulMarked');
                ulChildToExpand.style.display = 'block';
                navigationIconMobileChild.style.display = "none";

                if (topMenuIconUpMobileChild != null) {
                    topMenuIconUpMobileChild.style.display = "block";
                }
            }
        };
    }
})();

window.addEventListener('scroll', () => {
    if ((window as any).isScrollLocked) {
        // When in locked-mode in scrollytell, set the state to scroll-down and exit (no navigationmenu)
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
        return;
    }

    const currentScroll = window.pageYOffset;
    if (currentScroll <= 0) {
        body.classList.remove(scrollUp);
        return;
    }

    if (pageIntro) {
        if (currentScroll > pageIntro.clientHeight - 92 && body.classList.contains('StartPage')) {
            body.classList.add('scroll-below-page-intro');
        } else {
            body.classList.remove('scroll-below-page-intro');
        }
    }

    if (currentScroll > lastScroll && !body.classList.contains(scrollDown) && currentScroll > 200 && !lockMenu) {
        // down
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
    } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
        // up
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
});